<template>
    <div id="app" :class="isMarginTop?'header_top':''" v-if="reload">
        <c-header
            :class="routeName"
            v-show="tabBarIsshow"
            ></c-header>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
        <go-to-top :isRefreshShow='isRefreshShow' @refresh="refresh"></go-to-top>
    </div>
</template>

<script>
import cHeader from "@/components/common/header/header"
import goToTop from "@/components/common/goToTop/goToTop"
export default {
    name: "App",
    components: {
        cHeader,
        goToTop
    },
    data() {
        return {
            tabBarIsshow:false,
            from: null,
            routeName: null,
            isMarginTop: false,
            isRefreshShow: false,
            reload:true
        };
    },
    watch: {
        "$route":{
            handler(route){
                this.tabBarIsshow = route.meta.backIsshow
                this.routeName = route.name
                this.isMarginTop = route.meta.isMarginTop
                this.isRefreshShow = route.meta.isRefreshShow
            }
        }
    },
    methods:{
         clientLogin(url){   
            let that = this
            let parameter = {
                transactionType: '10020147',
                sysType: 'U',
                data:{
                    JSESSIONID: encodeURI(url)
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                // 存储用户信息
                if(res.resCode==='000000'){
                    localStorage.setItem('jsjUserId', res.userId)
                    localStorage.setItem('jsjUserName', res.accountName)
                    localStorage.setItem('jsjHeadImgUrl', res.headImgUrl)
                    localStorage.setItem('tokenQn', res.tokenQn)
                    localStorage.setItem('isCompUserName', res.isCompUserName)
                    localStorage.setItem('bingtype', res.bingtype)
                    localStorage.setItem('jsjMobile', res.cell)
                    let JSESSIONID = res.JSESSIONID
                    if(JSESSIONID){
                        JSESSIONID = JSESSIONID.replace(new RegExp("\\!","gm"),"=")
                        JSESSIONID = JSESSIONID.replace(new RegExp("\\*","gm"),"+")
                        JSESSIONID = JSESSIONID.replace(new RegExp("\\-","gm"),"/")
                        localStorage.setItem('JSESSIONID', JSESSIONID)
                        this.utils.setCookie('JSESSIONID', JSESSIONID, 1)
                    }
                    this.reloadFn()
                }
                
            })
        },
        reloadFn(){
            this.reload = false
            this.$nextTick(()=>{
                this.reload = true
            })
        },
        refresh(){
            this.reloadFn()
        }
    },
    created() {
        if(localStorage.getItem('JSESSIONID') != null){
            this.utils.setCookie('JSESSIONID', localStorage.getItem('JSESSIONID'),1)
        }
        this.tabBarIsshow = this.$route.meta.backIsshow
        this.isMarginTop = this.$route.meta.isMarginTop
        this.isRefreshShow = this.$route.meta.isRefreshShow

        // let hrefStr = window.location.href
        // if(localStorage.getItem("hrefStr")){
        //     if(hrefStr.indexOf("?")!==-1){
        //         let beforeUrlObj = this.utils.hrefObj(localStorage.getItem("hrefStr"))
        //         let afterUrlObj = this.utils.hrefObj(hrefStr)
        //         if(afterUrlObj.t&&beforeUrlObj.t!==afterUrlObj.t){
        //             localStorage.setItem('hrefStr',hrefStr)
        //         }
        //     }
            
        // }else{
        //     localStorage.setItem('hrefStr',hrefStr)
        // }
       
    },
    mounted(){
        let channelSrc = this.utils.hrefObj(window.location.href)
        if(channelSrc.from&&channelSrc.src){
            localStorage.setItem('channelSrc',channelSrc.src)
            // localStorage.setItem('channelSrc',decodeURI(channelSrc.src))
        }
        let userId = localStorage.getItem('jsjUserId')
        if(window.location.href.indexOf('?')!==-1){
            let urlObj = this.utils.hrefObj(window.location.href)   
            if(urlObj.t){
                let sessionId = (urlObj.t)
                this.clientLogin(sessionId)
            }
        }
        
    }
};
</script>

<style>
    html,body{
        background-color: #F3F3F3;
        width: 100%;
        height: auto;
        -webkit-text-size-adjust: 100%;
    }
    #app{
        width: 100%;
        height: auto;
    }
    .header_top {
        margin-top: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue